import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=c54adb88&scoped=true"
import script from "./ImageBlock.vue?vue&type=script&lang=js"
export * from "./ImageBlock.vue?vue&type=script&lang=js"
import style0 from "./ImageBlock.vue?vue&type=style&index=0&id=c54adb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54adb88",
  null
  
)

export default component.exports